<template>
    <div
        v-show="isOpen"
        ref="container"
        class="scope-modal-container animate-opacity"
    >
        <div
            :class="['scope-modal', `-${size}`]"
            v-on-click-outside="onClickOutside"
        >
            <div class="scope-modal__header">
                <div class="scope-modal__header__title">{{ title }}</div>
                <div class="scope-modal__header__subtitle" v-if="subtitle">
                    {{ subtitle }}
                </div>
                <Icon
                    v-if="isCloseButton"
                    icon="Cross"
                    class="scope-modal__close"
                    @click="close"
                />
                <Tooltip v-if="tooltip" position="bottom" alternative>
                    {{ tooltip }}
                </Tooltip>
            </div>
            <div :class="['scope-modal__body', bodyClass]">
                <slot name="body"></slot>
            </div>
            <div v-if="slots.footer" class="scope-modal__footer">
                <slot name="footer"></slot>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, useSlots } from 'vue';
import Icon from './Icon.vue';
import Tooltip from './Tooltip.vue';
import { vOnClickOutside } from '@vueuse/components';

const slots = useSlots();

const container = ref(null);

const props = defineProps({
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    bodyClass: { type: String, default: '' },
    size: { type: String, default: 'md' },
    isOpen: { type: Boolean, default: false },
    isCloseButton: { type: Boolean, default: true },
    tooltip: { type: String }
});

const emit = defineEmits(['close', 'clickOutside']);

const close = () => {
    // container.value.classList.remove('animate-opacity');
    // container.value.classList.add('animate-disappearing');
    emit('close');
};

const onClickOutside = () => {
    emit('clickOutside');
};
</script>

<style scoped lang="scss">
@import '../assets/styles/_main.scss';

// .animate-opacity {
//     animation: opac 0.5s;
// }

// .animate-disappearing {
//     animation: disappearing 0.5s;
// }

@keyframes opac {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes disappearing {
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
    }
}

.scope-modal-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    width: 100%;
    height: 100%;
    background: var(--overlay);
    top: 0;
    left: 0;
    z-index: 110;

    .scope-modal {
        display: flex;
        flex-direction: column;
        border-radius: 16px;
        gap: 24px;
        background: $card-background;
        padding: 16px;
        position: relative;

        &.-lg {
            width: 860px;
        }

        &.-md {
            width: 460px;
        }

        &.-sm {
            width: 420px;
        }

        &__header {
            display: flex;
            align-items: flex-start;
            flex-direction: column;
            gap: 4px;

            &__title {
                @include fz-20;
                font-weight: 600;
                color: $text-high-emphasis;
            }

            &__subtitle {
                color: $text-mid-emphasis;
                @include fz-14;
                font-weight: 500;
                letter-spacing: -0.2px;
            }
        }

        &__footer {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 12px;
        }

        &__close {
            color: $icons-mid-emphasis;
            position: absolute;
            top: 16px;
            right: 16px;
            cursor: pointer;
            @include transition-default(color);

            &:hover {
                color: $icons-high-emphasis;
            }
        }
    }
}
</style>
